import { render, staticRenderFns } from "./prebuild-pc-section.vue?vue&type=template&id=7f998d68&scoped=true&"
import script from "./prebuild-pc-section.vue?vue&type=script&lang=js&"
export * from "./prebuild-pc-section.vue?vue&type=script&lang=js&"
import style0 from "./prebuild-pc-section.vue?vue&type=style&index=0&id=7f998d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f998d68",
  null
  
)

export default component.exports